import React, { Component } from 'react'
import { Box, Button, Card, FormControl, IconButton, LinearProgress, MenuItem, Select, Tooltip, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Input } from '@mui/material';
import { MdDelete, MdDragIndicator, MdEdit } from 'react-icons/md';
import { isMobile } from 'react-device-detect';
import ApiRequestService from '../../../../components/ApiRequestService';
import SFTable from '../../../SFComponents/SFTable/SFTable';
import SFBarChart from '../../SFCharts/Bar/SFBarChart';
import { IoInformationCircle, IoRemoveCircleOutline, IoTimerSharp } from 'react-icons/io5';
import { TbTargetArrow } from 'react-icons/tb';
import moment from 'moment';
import Toggle from 'react-toggle';
import { PiCaretCircleDown, PiCaretCircleUp } from 'react-icons/pi';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { FaCirclePlus } from 'react-icons/fa6';
import { AppContext } from '../../../../AppContext';
import SFLineChart2 from '../../SFCharts/Line/SFLineChart2';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { toast } from 'react-toastify';
import SFNoData from '../../../SFComponents/SFNoData';

const defaultColumns = [
    {
        id: 'expand',
        name: 'Expand',
        width: "50px",
        visible: false,
    },
    {
        id: 'name',
        name: 'Category Name',
        width: "250px",
    },
    {
        id: 'accuracy_percent',
        name: 'Accuracy',
        width: "150px",
    },
    {
        id: 'time',
        name: 'Time Taken',
        width: "150px",

    },
    {
        id: 'add_to_practice_set',
        name: 'Add to Practice Set',
        width: "100px",
    }
]

const MAX_TIME = 30;

class PracticeSetsWidget extends Component {

    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            columns: defaultColumns,
            tab: 'my-sets',
            loading: true,
            assignments: [],
            selectedAssignment: null,

            topics: [],
            selectedTopic: null,

            practiceAssignments: [],
            selectedPracticeAssignment: null,

            categories: [],

            showDeleteDialog: false,
            deleteAssignment: null,
            showChangeNameDialog: false,
            newPracticeSetName: "",
        }
    }

    componentDidMount() {
        this.getMySets();
        // this.getByTopics();
        // this.getMySets();
    }


    componentDidUpdate(prevProps) {
        if (prevProps.selectedCourse?.course_id !== this.props.selectedCourse?.course_id
            || prevProps.selectedStudentUserName !== this.props.selectedStudentUserName) {
            this.setState({
                loading: true
            })
            this.getMySets();
        }

        if (
            (prevProps.newPracticeAssignment === null && this.props.newPracticeAssignment)
            ||
            (prevProps.newPracticeAssignment && this.props.newPracticeAssignment && prevProps.newPracticeAssignment.quiz_id !== this.props.newPracticeAssignment.quiz_id)
        ) {

            this.getMySets();
        }

        if (prevProps.selectedStudentUserName !== this.props.selectedStudentUserName) {
            this.getMySets();
        }
    }

    getByAssignments = () => {
        this.setState({ loading: true });
        let responsePromise = ApiRequestService({
            method: "POST",
            url: "/getByAssignments",
            data: {
                tabIndex: 0,
                courseID: this.props.selectedCourse?.course_id,
                userName: this.props.selectedStudentUserName
            }
        });

        responsePromise
            .then((res) => {
                if (res && res.data && res.data.data) {
                    if (res.data.data && res.data.data.length) {
                        let assignments = res.data.data;
                        let selectedAssignment = res.data.data[0];
                        if (this.props.activeQuizID && this.props.activeQuizID > 0) {
                            if (assignments && assignments.length) {
                                selectedAssignment = assignments.find(assign => assign.quizID === this.props.activeQuizID);
                            }
                        }
                        this.setState({
                            assignments: res.data.data,
                            selectedAssignment: selectedAssignment,
                            categories: selectedAssignment.categoryDataArr,
                        })
                    }
                } else {
                    this.setState({
                        assignments: [],
                        selectedAssignment: null,
                        categories: [],
                    });
                }
            })
            .catch((error) => {
                console.error("Error when getting Student Dashboard Data", error);
            })
            .finally(() => {
                this.setState({
                    loading: false
                })
            });
    }

    getBySkills = () => {
        this.setState({ loading: true });
        let responsePromise = ApiRequestService({
            method: "POST",
            url: "/getByAssignments",
            data: {
                tabIndex: 0,
                courseID: this.props.selectedCourse?.course_id,
                userName: this.props.selectedStudentUserName
            }
        });

        responsePromise
            .then((res) => {
                if (res && res.data && res.data.data) {
                    if (res.data.data && res.data.data.length) {
                        let assignments = res.data.data;
                        let selectedAssignment = res.data.data[0];
                        if (this.props.activeQuizID && this.props.activeQuizID > 0) {
                            if (assignments && assignments.length) {
                                selectedAssignment = assignments.find(assign => assign.quizID === this.props.activeQuizID);
                            }
                        }
                        this.setState({
                            assignments: res.data.data,
                            selectedAssignment: selectedAssignment,
                            categories: selectedAssignment.categoryDataArr,
                        })
                    }
                } else {
                    this.setState({
                        assignments: [],
                        selectedAssignment: null,
                        categories: [],
                    });
                }
            })
            .catch((error) => {
                console.error("Error when getting Student Dashboard Data", error);
            })
            .finally(() => {
                this.setState({
                    loading: false
                })
            });
    }

    getByTopics = () => {
        if (this.props.selectedStudentUserName === "all" &&
            this.props.savedTopicsForAllStudents && this.props.savedTopicsForAllStudents.length) {
            let firstTopic = this.props.savedTopicsForAllStudents[0];
            this.setState({
                topics: this.props.savedTopicsForAllStudents,
                selectedTopic: firstTopic,
                categories: firstTopic.categoryAnalytic ? firstTopic.categoryAnalytic : [],
            })
            this.props.handleUpdateCount(this.props.savedTopicsForAllStudents.length);
            return;
        }

        this.setState({
            loading: true,
        })

        let payload = {
            courseID: this.props.selectedCourse.course_id,
            sectionID: this.props.selectedInstructorSectionID,
            userName: this.props.selectedStudentUserName,
        }
        if (this.props.selectedStudentUserName === "all") {
            payload.allStudents = true
        }

        let responsePromise = ApiRequestService({
            method: "POST",
            url: "/getByTopics",
            data: payload
        });

        responsePromise
            .then((res) => {
                let count = 0;
                if (res && res.data && res.data.data) {
                    let topics = res.data.data;
                    this.setState({
                        topics: topics,
                    })
                    if (payload.userName === "all") {
                        let key = `${this.props.selectedCourse.course_id}_${this.props.selectedCourse.section_id}`;
                        this.props.updateSavedTopicsForAllStudents(key, topics)
                    }
                    count = topics.length;
                    if (topics && topics.length) {
                        let firstTopic = topics[0];
                        let categories = firstTopic.categoryAnalytic ? firstTopic.categoryAnalytic : [];
                        this.setState({
                            selectedTopic: firstTopic,
                            categories: categories,
                        })
                    }
                } else {
                    this.setState({
                        topics: [],
                        selectedTopic: null,
                        categories: []
                    })
                    count = 0;
                }
                this.props.handleUpdateCount(count);
            })
            .catch((error) => {
                console.error("Error when getting Student Dashboard Data", error);
            })
            .finally(() => {
                this.setState({
                    loading: false
                })
            });
    }

    getMySets = () => {
        this.setState({ loading: true });
        let responsePromise = ApiRequestService({
            method: "POST",
            url: "/getByAssignments",
            data: {
                tabIndex: 2,
                courseID: this.props.selectedCourse?.course_id,
                userName: this.props.selectedStudentUserName
            }
        });

        responsePromise
            .then((res) => {
                if (res && res.data && res.data.data) {
                    if (res.data.data && res.data.data.length) {
                        let assignments = res.data.data;
                        let selectedAssignment = res.data.data[0];
                        if (this.props.activeQuizID && this.props.activeQuizID > 0) {
                            if (assignments && assignments.length) {
                                selectedAssignment = assignments.find(assign => assign.quizID === this.props.activeQuizID);
                            }
                        }
                        this.setState({
                            practiceAssignments: res.data.data,
                            selectedPracticeAssignment: selectedAssignment,
                            categories: selectedAssignment.categoryDataArr,
                        })
                    }
                } else {
                    this.setState({
                        practiceAssignments: [],
                        selectedPracticeAssignment: null,
                        categories: [],
                    })
                }
            })
            .catch((error) => {
                console.error("Error when getting Student Dashboard Data", error);
            })
            .finally(() => {
                this.setState({
                    loading: false
                })
            });
    }


    handleExpand = (index) => {
        let value = this.state.categories[index].expand !== undefined ? !this.state.categories[index].expand : true;
        let updatedData = {
            ...this.state.categories[index],
            expand: value,
        }
        let updatedCategories = [...this.state.categories];
        updatedCategories[index] = updatedData;


        this.setState({
            categories: updatedCategories
        })

        let logText = "";
        let activityTypeID;
        if (this.state.tab === "by-assignments") {
            logText = "Assignments Tab";
            activityTypeID = 34;
        } else if (this.state.tab === "by-topics") {
            logText = "Topics Tab";
            activityTypeID = 35;
        } else if (this.state.tab === "by-skills") {
            logText = "Skills Completed Tab";
            activityTypeID = 34;
        } else {
            logText = "My Practice Sets Tab";
            activityTypeID = 36;
        }

        if (this.state.selectedAssignment && this.state.selectedAssignment.quizID) {
            const activityPayload = {
                toNomenclatureID: value ? 1 : 2,
                quizID: this.state.selectedAssignment?.quizID,
                subjectID: updatedData.subjectID,
                topicID: updatedData.topicID,
                categoryID: updatedData.categoryID,
                log: logText,
                activityTypeID: activityTypeID
            }
            if (this.props.selectedStudentUserName) {
                return;
            }
            if (this.context.onAddActivityLog) {
                this.context.onAddActivityLog(activityPayload);
            }
        }
    }

    handleToggle = (index, value) => {
        let updatedData = {
            ...this.state.categories[index],
            current: value,
        }
        let updatedCategories = [...this.state.categories];
        updatedCategories[index] = updatedData;

        this.setState({
            categories: updatedCategories
        })

        const activityPayload = {
            toNomenclatureID: value ? 4 : 3, // 4 - History, 3 - Current
            quizID: this.state.selectedAssignment.quizID,
            subjectID: updatedData.subjectID,
            topicID: updatedData.topicID,
            categoryID: updatedData.categoryID,
            activityTypeID: 26, // Toggle
        }

    }

    handleStartAssignment = (assignment) => {
        // console.debug("assignment>>??", assignment);
        let url = `/takequiz?quiz_id=${assignment.quizID || assignment.quiz_id}&course_id=${assignment.courseID || assignment.course_id}&section_id=${assignment.sectionID || assignment.section_Id}&quiz_name=${assignment.quizName || assignment.quiz_name}&quiz_type=${assignment.quiz_type || assignment.quizType}`;

        const activityPayload = {
            toNomenclatureID: 0, // clicked
            quizID: assignment.quizID,
            subjectID: 0,
            topicID: 0,
            categoryID: 0,
            activityTypeID: 22, // "Start Practice"
        }

        this.props.handleRoute(url)
    }

    handleTabClick = (tabName) => {
        let columns = [...defaultColumns];
        this.setState({ tab: tabName });
        if (tabName === "by-assignments" || tabName === "by-skills") {
            this.setState({
                columns: columns,
            })
            if (tabName === "by-assignments") {
                this.getByAssignments();
            } else {
                this.getBySkills();
            }
        } else if (tabName === "by-topics") {
            this.setState({
                columns: columns,
            })
            this.getByTopics();
        } else {
            columns.pop();
            this.setState({
                columns: columns,
            })
            this.getMySets();
        }
        let logText = "";
        if (tabName === "by-assignments") {
            logText = "Assignments Tab"
        } else if (tabName === "by-topics") {
            logText = "Topics Tab"
        } else {
            logText = "My Practice Sets Tab"
        }
        let activityLogPayload = {
            toNomenclatureID: 0, // clicked
            log: logText,
            activityTypeID: 33, // Tab Picked
            courseID: this.props.selectedCourse.course_id,
        }
        if (this.props.selectedStudentUserName) {
            return;
        }
        this.context.onAddActivityLog(activityLogPayload);
    }

    getDropdownTilte = () => {
        let name = "";
        switch (this.state.tab) {
            case "by-assignments":
                name = "Pick an Assignment"
                break;
            case "by-topics":
                name = "Pick a Topic"
                break;
            case "my-sets":
                name = "Pick a Practice Set"
                break;

            default:
                break;
        }

        return name;
    }

    renderRow(data, index, isInstructor, renderRowProps) {

        function getReadableTime(timeInSec) {
            if (timeInSec <= 60) {
                return `${timeInSec} sec`
            }
            let min = moment.duration(timeInSec, 'seconds').minutes()
            let sec = moment.duration(timeInSec, 'seconds').seconds()

            return `${min}m ${sec}s`
        }

        let categories = this.dataArr;
        function getLabelsMaxCount() {
            let count = 0;

            if (categories && categories.length) {
                categories.forEach(cat => {
                    let l = cat?.categoryPracticeDataArr && cat?.categoryPracticeDataArr ? cat.categoryPracticeDataArr.length : 0;
                    if (l > count) {
                        count = l;
                    }
                })
            }

            return count;
        }

        let firstAccuracy = 0;
        let firstTimeInSec = 0;

        if (data && data.categoryPracticeDataArr && data.categoryPracticeDataArr.length) {
            let firstAttempt = data.categoryPracticeDataArr[0]
            firstAccuracy = firstAttempt.accuracyPercent;
            firstTimeInSec = firstAttempt.time;
        }

        let catKey = `${data.subjectID}_${data.topicID}_${data.categoryID}`
        let catIsAlreadyAdded = false;
        if (this.selectedCategories && this.selectedCategories.length) {
            this.selectedCategories.forEach(selectedCat => {
                if (`${selectedCat.subjectID}_${selectedCat.topicID}_${selectedCat.categoryID}` === catKey) {
                    catIsAlreadyAdded = true;
                }
            });
        }

        /* let isCurrent = false;
        if (data.current === undefined || data.current) {
            isCurrent = true;
        }

        let categoryDataArr = data.categoryPracticeDataArr;
        if (!isCurrent) {
            categoryDataArr = data.categoryPracticeDataAcrossArr;
        } */
        let isCurrent = false;
        let categoryDataArr = [];
        // console.debug("data>>??--", data);
        if (renderRowProps.tab === "by-assignments" || renderRowProps.tab === "by-skills") {
            categoryDataArr = data.categoryPracticeDataArr;
        } else if (renderRowProps.tab === "by-topics") {
            categoryDataArr = data.categoryPracticeDataArr;
        } else if (renderRowProps.tab === "my-sets") {
            categoryDataArr = data.categoryPracticeDataArr;
        }
        // console.debug("categoryDataArr>>??", categoryDataArr, renderRowProps.tab, data)

        let latestAccuracy = 0;
        let latestTimeInSec = 0;
        if (categoryDataArr?.length) {
            let lastData = categoryDataArr[categoryDataArr.length - 1];
            if (lastData) {
                latestAccuracy = lastData.accuracyPercent;
                latestTimeInSec = lastData.time;
            }
        }

        return (
            <div className='mx-2'>


                <div className='sf-table-row cursor-pointer'
                    onClick={() => {
                        this.handleExpand(index);
                    }}>

                    {/* Column: Expand Icon */}
                    <div className='sf-table-row-div' style={{ width: renderRowProps.columns[0].width }}>
                        {data.expand ?
                            <PiCaretCircleUp fontSize={24} color='#333' />
                            :
                            <PiCaretCircleDown fontSize={24} color='#333' />
                        }
                    </div>

                    {/* Column: Category Name */}
                    <div className='sf-table-row-div text-align-left' style={{ width: renderRowProps.columns[1].width }}>
                        {data.name}
                    </div>

                    {/* Column: Accuracy */}
                    <div className='sf-table-row-div' style={{ width: renderRowProps.columns[2].width }}>
                        <div className='w-100 h-100 text-align-center'>
                            <div>{latestAccuracy}%</div>
                            <div>
                                <LinearProgress
                                    style={{ height: '8px', borderRadius: '75px' }}
                                    variant="determinate" value={latestAccuracy} />
                            </div>
                        </div>
                    </div>

                    {/* Column: Time Taken */}
                    <div className='sf-table-row-div' style={{ width: renderRowProps.columns[3].width }}>
                        <div className='text-center' style={{ color: '#0F7C27' }}>
                            <div className='fontClass-22'>
                                {getReadableTime(latestTimeInSec)}
                                {/* {data.masteryTime.toFixed(1)} */}
                                {/* {moment.duration(data.masteryTime, 'seconds').seconds()} */}

                            </div>
                            {/* <div>{data.speed_message}</div> */}
                        </div>
                    </div>

                    {/* Column: Add to Pratice Set */}
                    {renderRowProps.tab !== "my-sets" ?
                        <div className='sf-table-row-div' style={{ width: renderRowProps.columns[4].width }}>
                            <div>
                                {catIsAlreadyAdded ?
                                    <IconButton
                                        disabled={renderRowProps.selectedStudentUserName}
                                        color='primary' onClick={(e) => {
                                            e.stopPropagation();
                                            this.handleRemovFromPractice(data, index);

                                            let quiz = null;
                                            if (renderRowProps.tab === "by-assignments") {
                                                quiz = renderRowProps.selectedAssignment;
                                            } else if (renderRowProps.tab === "by-topics") {
                                                quiz = renderRowProps.selectedTopic;
                                            } else {
                                                quiz = renderRowProps.selectedPracticeAssignment;
                                            }
                                            let activityLogPayload = {
                                                toNomenclatureID: 0, // clicked
                                                quizID: quiz?.quizID,
                                                subjectID: data.subjectID,
                                                topicID: data.topicID,
                                                categoryID: data.categoryID,
                                                log: "Remove from Practice Set Cart",
                                                activityTypeID: 38, // Category Removed
                                                courseID: renderRowProps.courseID,
                                            }
                                            // console.debug("activityLogPayload>>??", activityLogPayload, quiz);
                                            if (this.props.selectedStudentUserName) {
                                                return;
                                            }
                                            renderRowProps.onAddActivityLog(activityLogPayload);

                                        }}>
                                        <IoMdCloseCircleOutline />
                                    </IconButton>
                                    :
                                    <IconButton color='primary'
                                        disabled={renderRowProps.selectedStudentUserName}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.handleAddToPractice(data, index);
                                            // console.debug("data>>??", data)
                                            let quiz = null;
                                            if (renderRowProps.tab === "by-assignments") {
                                                quiz = renderRowProps.selectedAssignment;
                                            } else if (renderRowProps.tab === "by-topics") {
                                                quiz = renderRowProps.selectedTopic;
                                            } else {
                                                quiz = renderRowProps.selectedPracticeAssignment;
                                            }
                                            let activityLogPayload = {
                                                toNomenclatureID: 0, // clicked
                                                quizID: quiz?.quizID,
                                                subjectID: data.subjectID,
                                                topicID: data.topicID,
                                                categoryID: data.categoryID,
                                                log: "Add to Practice Set Cart",
                                                activityTypeID: 37, // Category Added
                                                courseID: renderRowProps.courseID,
                                            }
                                            // console.debug("activityLogPayload>>??", activityLogPayload, quiz);
                                            renderRowProps.onAddActivityLog(activityLogPayload);

                                        }}
                                    >
                                        <FaCirclePlus />
                                    </IconButton>
                                }
                            </div>
                        </div>
                        : null}
                    {/* <div className='sf-table-row-div' style={{ width: '180px' }}>
                        {catIsAlreadyAdded ? <Button variant='outlined'
                        onClick={() => {
                            this.handleRemovFromPractice(data, index)
                        }}
                        >
                            Remove from Practice Set
                        </Button> :
                            <Button variant='outlined' onClick={() => {
                                this.handleAddToPractice(data, index)
                            }}>Add to Practice Set</Button>
                        }
                    </div> */}
                </div>

                <div style={{
                    display: data.expand ? "block" : 'none'
                }}>
                    {/* {data.categoryPracticeDataArr === null ? : } */}
                    <Box style={{
                        height: '400px',
                        width: '100%',
                        background: 'white',
                        // gap: "2rem",
                    }} className="d-flex flex-column justify-content-center align-items-center">

                        {/*  {renderRowProps.tab !== "by-topics" ?
                            <div className='d-flex justify-content-center align-items-center mt-3'>
                                <Tooltip title={
                                    <Typography fontSize={12} color='#fff'>
                                        Current assignment/set data
                                    </Typography>
                                } placement="top" arrow>

                                    <Typography fontSize={14}
                                        fontWeight={isCurrent ? 800 : 500}
                                    >
                                        <IoInformationCircle fontSize={16} color='#646a6e' /> Current
                                    </Typography>
                                </Tooltip>


                                <Toggle
                                    id="accuracy_or_time"
                                    icons={false}
                                    className="mx-3"
                                    checked={!isCurrent}
                                    onChange={() => {
                                        this.handleToggle(index, !isCurrent)
                                    }}
                                />
                                <Tooltip title={
                                    <Typography fontSize={12} color='#fff'>
                                        Data across all assignments/sets
                                    </Typography>
                                } placement="top" arrow>
                                    <Typography fontSize={14}
                                        fontWeight={!isCurrent ? 800 : 500}
                                    >
                                        History <IoInformationCircle fontSize={16} color='#646a6e' />
                                    </Typography>
                                </Tooltip>
                            </div>
                            : null} */}
                        <div className="d-flex justify-content-center align-items-center h-100 w-100" style={{
                            marginTop: "-8px",
                            gap: "2rem",
                        }}>
                            <SFLineChart2
                                chartType="accuracy"
                                title={
                                    <div className='pl-5'>
                                        <center>
                                            <Typography fontSize={14} fontWeight={600}>
                                                <TbTargetArrow fontSize={22} />
                                                {renderRowProps.selectedStudentUserName === "all" ? "Mean Accuracy" : "Accuracy %"}
                                            </Typography>
                                        </center>
                                    </div>
                                }
                                format="%"
                                type={"linear"}
                                xAxisLabel={"Attempts #"}
                                yAxisLabel={renderRowProps.selectedStudentUserName === "all" ? "Mean Accuracy %" : "Accuracy %"}
                                labelsMaxCount={categoryDataArr?.length ? categoryDataArr?.length : 0}
                                //labelsArr={data?.categoryPracticeDataArr?.map((cp, index) => `${cp.quizName}`)}
                                dataArr={categoryDataArr?.map((cp, index) => cp.accuracyPercent)}
                                min={0}
                                max={100}
                                stepSize={20}
                                chart="Accuracy"
                            />
                            <SFLineChart2
                                chartType="time"
                                width={"300px"}
                                title={
                                    <div className='pl-5'>
                                        <center>
                                            <Typography fontSize={14} fontWeight={600}>
                                                <IoTimerSharp fontSize={22} />
                                                {renderRowProps.selectedStudentUserName === "all" ? "Median Time Taken (min)" : "Time Taken (min)"}
                                            </Typography>
                                        </center>
                                    </div>
                                }
                                format="%"
                                type={"linear"}
                                xAxisLabel={"Attempts #"}
                                yAxisLabel={renderRowProps.selectedStudentUserName === "all" ? "Median Time Take (min)" : "Time Take (min)"}
                                labelsMaxCount={categoryDataArr?.length ? categoryDataArr?.length : 0}
                                //labelsArr={data?.categoryPracticeDataArr?.map((cp, index) => cp.quizName)}
                                dataArr={categoryDataArr?.map((cp, index) => parseFloat((cp.time / 60).toFixed(1)))}
                                min={0}
                                max={MAX_TIME}
                                stepSize={10}
                                chart="Time"
                            />
                            {/* <>
                                    <SFBarChart
                                        width={"300px"}
                                        title={
                                            <div className='pl-5'>
                                                <center>
                                                    <Typography fontSize={14} fontWeight={600}>
                                                        <TbTargetArrow fontSize={22} /> Accuracy %
                                                    </Typography>
                                                </center>
                                            </div>
                                        }
                                        format="%"
                                        type={"linear"}
                                        xAxisLabel={"Attempts #"}
                                        yAxisLabel={"Accuracy %"}
                                        isPractice={false}
                                        labels={categoryDataArr ? categoryDataArr.map((_, index) => index + 1) : []}
                                        dataArr={categoryDataArr ? categoryDataArr?.map(cat => cat.accuracyPercent) : []}
                                        practiceDataArr={categoryDataArr ? categoryDataArr?.map(cat => cat.accuracyGoal) : []}
                                        min={0}
                                        max={100}
                                        stepSize={20}
                                    />
                                    <SFBarChart
                                        width={"300px"}
                                        title={
                                            <div className='pl-5'>
                                                <center>
                                                    <Typography fontSize={14} fontWeight={600}>
                                                        <IoTimerSharp fontSize={22} /> Time Taken (min)
                                                    </Typography>
                                                </center>
                                            </div>
                                        }
                                        format="m"
                                        type={"logarithmic"}
                                        xAxisLabel={"Attempts #"}
                                        yAxisLabel={"Time Take (min)"}
                                        isPractice={false}
                                        labels={categoryDataArr ? categoryDataArr?.map((_, index) => index + 1) : []}
                                        dataArr={categoryDataArr ? categoryDataArr?.map(cat => {
                                            return parseFloat((cat.time / 60).toFixed(1))
                                        }) : []}
                                        practiceDataArr={categoryDataArr ? categoryDataArr?.map(cat => {
                                            return cat.timeGoal
                                        }) : []}
                                        min={0}
                                        max={10}
                                        stepSize={1}
                                    />
                                </> */}
                        </div>
                    </Box>
                </div >

                {/* <div className='justify-content-center align-items-center pb-4 pt-3' style={{
                    gap: "2rem",
                    display: data.expand ? "flex" : 'none',
                    background: "#fff",
                }}>
                    <div className='d-flex justify-content-center align-items-center' style={{
                        gap: "6px"
                    }}>
                        <div style={{ background: "#0077B9", width: "30px", height: "7px" }}></div>
                        Graded
                    </div>
                    <div className='d-flex justify-content-center align-items-center' style={{
                        gap: "6px"
                    }}>
                        <div style={{ background: "#FF5287", width: "30px", height: "7px" }}></div>
                        Practice
                    </div>
                    <div className='d-flex justify-content-center align-items-center' style={{
                        gap: "6px"
                    }}>
                        <div style={{ background: "#D6AAAC", width: "30px", height: "7px", borderRadius: "15px" }}></div>
                        Goal
                    </div>
                </div> */}

            </div >
        )
    }

    handleDeleteSet = () => {
        if (this.state.selectedPracticeAssignment === null) return;
        let responsePromise = ApiRequestService({
            method: "POST",
            url: "/deleteSet",
            data: {
                quizID: this.state.selectedPracticeAssignment.quizID
            }
        });
        responsePromise
            .then((res) => {
                if (res && res.data && res.data.data) {
                    let filteredAssignments = this.state.practiceAssignments.filter(assing => assing.quizID !== this.state.deleteAssignment.quizID);
                    this.setState({
                        practiceAssignments: filteredAssignments,
                    })
                    toast.success('The practice set was deleted successfully.', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        pauseOnFocusLoss: false,
                        theme: "light",
                    });
                    if (filteredAssignments && filteredAssignments.length) {
                        this.setState({
                            selectedPracticeAssignment: filteredAssignments[0],
                            categories: filteredAssignments[0]?.categoryDataArr
                        })
                    }
                }
            })
            .catch((error) => {
                console.error("Error when deleting set", error);
            })
            .finally(() => {
                this.setState({
                    showDeleteDialog: false,
                    deleteAssignment: null,
                })
            });
    };

    updatePracticeSet = () => {
        /* if (specialCharacterValidation(this.state.newPracticeSetName)) {
            toast.error('Assignment Name cannot contain( /, \\, * , : , comma ,@ , & , % , $ , # , !)', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                pauseOnFocusLoss: false,
                theme: "light",
            });
            return;
        } */
        let payload = {
            quizID: this.state.selectedPracticeAssignment.quizID,
            quizName: this.state.newPracticeSetName,
        }

        if (payload.quizID && payload.quizName) {
            let responsePromise = ApiRequestService({
                method: "POST",
                url: "/updateSet",
                data: payload
            });
            responsePromise
                .then((res) => {
                    if (res && res.data && res.data.data) {
                        toast.success('Updated practice set name', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            pauseOnFocusLoss: false,
                            theme: "light",
                        });
                        let updatedSelectedAssignment = null
                        let updatedAssignments = this.state.practiceAssignments.map(assign => {
                            let quizName = assign.quizName;
                            if (assign.quizID === payload.quizID) {
                                quizName = payload.quizName;
                                updatedSelectedAssignment = {
                                    ...assign,
                                    quizName: payload.quizName,
                                };
                            }
                            return {
                                ...assign,
                                quizName: quizName,
                            }
                        })
                        this.setState({
                            practiceAssignments: updatedAssignments,
                            selectedPracticeAssignment: updatedSelectedAssignment
                        })

                    }
                })
                .catch((error) => {
                    console.error("Error when updating set name", error);
                })
                .finally(() => {
                    this.setState({
                        showChangeNameDialog: false,
                        newPracticeSetName: "",
                    })
                });
        } else {
            toast.error("Practice set name is empty")
        }
    }

    render() {

        const {
            selectedCategories, handleAddCategory, handleRemoveCategory, handleAddCategories, onAddActivityLog
        } = this.context;

        return (
            <Card className='h-100 w-100 position-relative'
                style={{ backgroundColor: '#fff', position: 'relative' }} sx={{ boxShadow: 3, borderRadius: 2 }}
            >
                <div className='d-flex justify-content-between align-items-end p-3'>
                    <Typography
                        fontSize={isMobile ? 16 : 18}
                        fontWeight={'500'} >
                        Build your own Practice Sets
                        <Tooltip title={
                            <Typography color="#fff">
                                You can also create practice sets from picking categories from "Recommendation" or "Performance Analytics"
                            </Typography>}
                            placement='top'
                            arrow
                        >
                            <span>
                                <IoInformationCircle color='#646a6e' />
                            </span>
                        </Tooltip>
                    </Typography>
                    <div className='cursor-pointer drag-handle' style={{ cursor: 'move' }}>
                        <MdDragIndicator fontSize={24} />
                    </div>
                </div>

                <div className='performance-tab mb-3'>
                    <div className={`${this.state.tab === 'my-sets' ? 'active' : ''}`}
                        onClick={() => this.handleTabClick("my-sets")}
                    >My Practice Sets</div>
                    {this.context.isSpecialCourse ?
                        <div className={`${this.state.tab === 'by-skills' ? 'active' : ''}`}
                            onClick={() => this.handleTabClick("by-skills")}
                        >Skills Completed</div>
                        :
                        <div className={`${this.state.tab === 'by-assignments' ? 'active' : ''}`}
                            onClick={() => this.handleTabClick("by-assignments")}
                        >Assignments</div>
                    }
                    <div className={`${this.state.tab === 'by-topics' ? 'active' : ''}`}
                        onClick={() => this.handleTabClick("by-topics")}
                    >Topics</div>
                </div>

                {this.state.loading ?
                    <div className='h-100 mt-5 position-relative px-4'>
                        <div className='w-100 position-relative'>
                            <Skeleton className='my-2' count={5} />
                        </div>
                    </div>
                    :

                    (
                        (this.state.assignments.length === 0 && this.state.tab === "by-assignments")
                            ||
                            (this.state.assignments.length === 0 && this.state.tab === "by-skills")
                            ||
                            (this.state.topics.length === 0 && this.state.tab === "by-topics")
                            ||
                            (this.state.practiceAssignments.length === 0 && this.state.tab === "my-sets")
                            ?
                            <div className='d-flex w-full justify-content-center align-items-center mt-5 mx-5 pt-5'>
                                {this.state.tab === "by-assignments" && this.state.assignments.length === 0 ?
                                    <SFNoData
                                        title={"You have not completed any assignments yet"}
                                        description={"Assignments that are completed will be shown here"}
                                    />
                                    : null}
                                {this.state.tab === "by-skills" && this.state.assignments.length === 0 ?
                                    <SFNoData
                                        title={"You have not completed any skills yet"}
                                        description={"Skills that are completed will be shown by topics here"}
                                    />
                                    : null}
                                {this.state.tab === "my-sets" && this.state.practiceAssignments.length === 0 ?

                                    <SFNoData
                                        title="No Practice Sets Created"
                                        description={
                                            <div className='text-left'>
                                                Create your practice sets from,
                                                <ol className='mt-2'>
                                                    <li>Recommendation</li>
                                                    <li>Performance Analytics</li>
                                                    <li>Skills Completed</li>
                                                    <li>Topics</li>
                                                </ol>
                                            </div>
                                        }
                                    />
                                    : null}
                                {this.state.tab === "by-topics" && this.state.topics.length === 0 ?
                                    <SFNoData
                                        title={"You have not completed any assignments yet"}
                                        description={"Assignments that are completed will be shown by topics here"}
                                    />
                                    : null}
                            </div>
                            /*  <div className='empty-container'>
                                 <div className='empty-div'>
                                     <Typography fontSize={24} fontWeight={700} sx={{ color: "#9F9F9F" }}>
                                         You have not created any practice sets
                                     </Typography>
                                     <div className='mt-4 text-secondary'>
                                         Pick categories from recommendation or performance or <span className='text-link' onClick={() => {
                                             this.handleTabClick("by-assignments")
                                         }}>assignments</span> or <span className='text-link' onClick={() => {
                                             this.handleTabClick("by-topics")
                                         }}>topics</span> and create your own practice set
                                     </div>
                                 </div>
                             </div> */
                            :
                            <React.Fragment>
                                <div className='d-flex justify-content-start align-items-center mx-4' style={{ gap: "1rem" }}>
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <div className='mr-2'>
                                            <Typography fontWeight={600}>
                                                {this.getDropdownTilte()}
                                            </Typography>
                                        </div>
                                        <div style={{
                                            width: "230px",
                                        }}>
                                            {this.state.tab === "by-assignments" || this.state.tab === "by-skills" ?
                                                <FormControl fullWidth>
                                                    <Select
                                                        labelId="select-topic"
                                                        id="select-topic"
                                                        size='small'
                                                        value={this.state.selectedAssignment?.quizID || ""}
                                                        onChange={(e) => {
                                                            let selectedAssignment = this.state.assignments.find(assignment => assignment.quizID === e.target.value);
                                                            if (selectedAssignment) {
                                                                this.setState({
                                                                    selectedAssignment,
                                                                    categories: selectedAssignment.categoryDataArr,
                                                                })
                                                            }

                                                            if (!this.props.selectedStudentUserName) {
                                                                let activityLogPayload = {
                                                                    toNomenclatureID: 0, // clicked
                                                                    log: "",
                                                                    activityTypeID: 34, // Assignments
                                                                    quizID: selectedAssignment.quizID,
                                                                    courseID: this.props.selectedCourse.course_id,
                                                                }
                                                                onAddActivityLog(activityLogPayload);
                                                            }

                                                        }}
                                                    >
                                                        {this.state.assignments.map(assignment => {
                                                            return (
                                                                <MenuItem value={assignment.quizID}>{assignment.quizName}</MenuItem>
                                                            )
                                                        })}
                                                    </Select>
                                                </FormControl>
                                                : null}
                                            {this.state.tab === "by-topics" ?
                                                <FormControl fullWidth>
                                                    <Select
                                                        labelId="select-topic"
                                                        id="select-topic"
                                                        size='small'
                                                        value={`${this.state.selectedTopic?.subjectID}_${this.state.selectedTopic?.topicID}` || null}
                                                        onChange={(e) => {
                                                            let selectedTopic = this.state.topics.find(topic => `${topic.subjectID}_${topic.topicID}` === e.target.value);
                                                            if (selectedTopic) {
                                                                this.setState({
                                                                    selectedTopic,
                                                                    categories: selectedTopic.categoryAnalytic ? selectedTopic.categoryAnalytic : [],
                                                                })
                                                            } else {
                                                                this.setState({
                                                                    selectedTopic: null,
                                                                    categories: [],
                                                                })
                                                            }

                                                            let activityLogPayload = {
                                                                toNomenclatureID: 0, // clicked
                                                                log: "",
                                                                activityTypeID: 35, // Topics
                                                                subjectID: selectedTopic.subjectID,
                                                                topicID: selectedTopic.topicID,
                                                                courseID: this.props.selectedCourse.course_id,
                                                            }
                                                            onAddActivityLog(activityLogPayload);
                                                        }}
                                                    >
                                                        {this.state.topics.map(topics => {
                                                            return (
                                                                <MenuItem value={`${topics.subjectID}_${topics.topicID}`}>{topics.name}</MenuItem>
                                                            )
                                                        })}
                                                    </Select>
                                                </FormControl>
                                                : null}
                                            {this.state.tab === "my-sets" ?
                                                <FormControl fullWidth>
                                                    <Select
                                                        labelId="select-topic"
                                                        id="select-topic"
                                                        size='small'
                                                        value={this.state.selectedPracticeAssignment?.quizID || null}
                                                        onChange={(e) => {
                                                            let selectedPracticeAssignment = this.state.practiceAssignments.find(pa => pa.quizID === e.target.value);
                                                            if (selectedPracticeAssignment) {
                                                                this.setState({
                                                                    selectedPracticeAssignment,
                                                                    categories: selectedPracticeAssignment.categoryDataArr,
                                                                })
                                                            }
                                                            let activityLogPayload = {
                                                                toNomenclatureID: 0, // clicked
                                                                log: "",
                                                                activityTypeID: 36, // My Practice Sets
                                                                quizID: selectedPracticeAssignment.quizID,
                                                                courseID: this.props.selectedCourse.course_id,
                                                            }
                                                            onAddActivityLog(activityLogPayload);
                                                        }}
                                                    >
                                                        {this.state.practiceAssignments.map(pa => {
                                                            return (
                                                                <MenuItem value={pa.quizID}>{pa.quizName}</MenuItem>
                                                            )
                                                        })}
                                                    </Select>
                                                </FormControl>
                                                : null}
                                        </div>
                                        {this.state.tab === "my-sets" ?
                                            <>
                                                <Button variant='contained' className='ml-2'
                                                    disabled={this.props.selectedStudentUserName}
                                                    onClick={() => {
                                                        this.handleStartAssignment(this.state.selectedPracticeAssignment);
                                                    }}
                                                >
                                                    Start Practice Set
                                                </Button>
                                                <IconButton className='ml-2' color='primary'
                                                    disabled={this.props.selectedStudentUserName}
                                                    onClick={() => {
                                                        this.setState({
                                                            showChangeNameDialog: true,
                                                            newPracticeSetName: this.state.selectedPracticeAssignment?.quizName,
                                                        })
                                                    }}>
                                                    <MdEdit />
                                                </IconButton>
                                                <IconButton className='ml-2' color='primary'
                                                    disabled={this.props.selectedStudentUserName}
                                                    onClick={() => {
                                                        this.setState({
                                                            showDeleteDialog: true,
                                                            deleteAssignment: this.state.selectedPracticeAssignment,
                                                        })
                                                    }}>
                                                    <MdDelete />
                                                </IconButton>
                                            </>
                                            : null}
                                    </div>
                                    {/* <div>
                                    <Button
                                        onClick={() => {
                                            this.handleStartAssignment(this.state.selectedAssignment)
                                        }}
                                        variant='contained'>Start Practice Set</Button>
                                </div> */}

                                    {/* Delete practice set */}
                                    {/* <div>
                                    <IconButton>

                                    </IconButton>
                                </div> */}
                                </div>

                                <div className='mx-3 mt-3'>
                                    <SFTable
                                        columns={this.state.columns}
                                        dataArr={this.state.categories && this.state.categories.length ? this.state.categories : null}
                                        renderRow={this.renderRow}
                                        handleExpand={this.handleExpand}
                                        handleToggle={this.handleToggle}
                                        handleAddToPractice={handleAddCategory}
                                        handleRemovFromPractice={handleRemoveCategory}
                                        selectedCategories={selectedCategories}
                                        selectedAssignment={this.state.selectedAssignment}
                                        selectedTopic={this.state.selectedTopic}
                                        selectedPracticeAssignment={this.state.selectedPracticeAssignment}
                                        tableStyle={{
                                            height: "440px",
                                            overflow: "auto"
                                        }}
                                        onAddActivityLog={(payload) => {
                                            if (this.props.selectedStudentUserName) return null;
                                            onAddActivityLog(payload)
                                        }}
                                        tab={this.state.tab}
                                        courseID={this.props.selectedCourse.course_id}
                                        selectedStudentUserName={this.props.selectedStudentUserName}
                                    />

                                </div>
                            </React.Fragment>
                    )
                }

                {/* Practice set name change dialog */}
                <Dialog open={this.state.showChangeNameDialog}
                    fullWidth
                    maxWidth='sm'
                    onClose={() => {
                        this.setState({
                            showChangeNameDialog: false,
                            newPracticeSetName: null,
                        })
                    }}
                >
                    <DialogTitle fontWeight={600}>Update Practice Set Name</DialogTitle>
                    <DialogContent>
                        <Input
                            size='medium'
                            style={{
                                width: "100%",
                                fontSize: '1.2rem'
                            }}
                            placeholder='Enter your practice set name'
                            value={this.state.newPracticeSetName}
                            onChange={(event) => {
                                this.setState({
                                    newPracticeSetName: event.target.value,
                                })
                            }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant='outlined'
                            onClick={() => {
                                this.setState({
                                    showChangeNameDialog: false,
                                    newPracticeSetName: null,
                                })
                            }}>Cancel</Button>
                        <Button
                            variant='contained'
                            disabled={this.state.newPracticeSetName === ""}
                            onClick={() => {
                                this.updatePracticeSet()
                            }} autoFocus>
                            Update
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Delete set dialog */}
                <Dialog open={this.state.showDeleteDialog}
                    fullWidth
                    maxWidth='sm'
                    onClose={() => {
                        this.setState({
                            showDeleteDialog: false,
                            deleteAssignment: null,
                        })
                    }}
                >
                    <DialogTitle fontWeight={600}>Delete My Set</DialogTitle>
                    <DialogContent>
                        <Typography fontSize={16}>
                            Are you sure you want to delete "{this.state.deleteAssignment?.quizName}"?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant='outlined'
                            onClick={() => {
                                this.setState({
                                    showDeleteDialog: false,
                                    deleteAssignment: null,
                                })
                            }}>Cancel</Button>
                        <Button
                            variant='contained'
                            onClick={() => {
                                this.handleDeleteSet();
                            }} autoFocus>
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>

            </Card>
        )
    }
}

export default PracticeSetsWidget;
